(function(){
'use strict';
if (document.getElementById('ripple')) {
// Signature moment: ink-drop ripple into water, behind the hero headline
const canvas = document.getElementById('ripple');
const ctx = canvas.getContext('2d');
let w, h, dpr;
function resize(){
  dpr = Math.min(window.devicePixelRatio||1, 2);
  w = canvas.offsetWidth; h = canvas.offsetHeight;
  canvas.width = w*dpr; canvas.height = h*dpr;
  ctx.setTransform(dpr,0,0,dpr,0,0);
}
window.addEventListener('resize', resize);
resize();

let ripples = [];
function addRipple(x,y,big){
  ripples.push({x,y,r:0,maxR: big? Math.max(w,h)*0.9 : 260, alpha:0.5, speed: big? 6:5});
}
setTimeout(()=> addRipple(w*0.78, h*0.32, true), 300);

canvas.addEventListener('click', e=>{
  const rect = canvas.getBoundingClientRect();
  addRipple(e.clientX-rect.left, e.clientY-rect.top, false);
});

function draw(){
  ctx.clearRect(0,0,w,h);
  ripples.forEach(rp=>{
    rp.r += rp.speed;
    rp.alpha = Math.max(0, 0.5 * (1 - rp.r/rp.maxR));
    ctx.beginPath();
    ctx.arc(rp.x, rp.y, rp.r, 0, Math.PI*2);
    ctx.strokeStyle = `rgba(120,150,190,${rp.alpha})`;
    ctx.lineWidth = 1.2;
    ctx.stroke();
  });
  ripples = ripples.filter(rp=> rp.alpha > 0.01);
  requestAnimationFrame(draw);
}
draw();

setInterval(()=>{
  if(Math.random() < 0.5){
    addRipple(Math.random()*w, Math.random()*h*0.7, false);
  }
}, 3200);
}

// Tap to flip product cards to the back print (hover already handles desktop)
document.querySelectorAll('.p-card').forEach(card=>{
  card.addEventListener('click', (e)=>{ if(e.target.closest('button,form')) return; card.classList.toggle('flipped'); });
});

// Shorts gallery: swipe carousel (native scroll-snap) + arrows, dots, colorway switch
(function(){
  const root = document.getElementById('shorts-gallery');
  if(!root) return;
  const track = root.querySelector('.g-track');
  const slides = Array.from(root.querySelectorAll('.g-slide'));
  const dots = Array.from(root.querySelectorAll('.g-dot'));
  const chips = Array.from(root.querySelectorAll('.g-chip'));
  const colorLabel = root.querySelector('.g-color');
  const count = root.querySelector('.g-count');
  const prev = root.querySelector('.g-prev');
  const next = root.querySelector('.g-next');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let current = -1, ticking = false;

  function goTo(i){
    i = Math.max(0, Math.min(slides.length-1, i));
    track.scrollTo({left: slides[i].offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth'});
  }
  function currentIndex(){
    const max = track.scrollWidth - track.clientWidth;
    if(track.scrollLeft >= max - 2) return slides.length-1;
    const step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
    return Math.round(track.scrollLeft / step);
  }
  function update(){
    ticking = false;
    const i = currentIndex();
    if(i === current) return;
    current = i;
    dots.forEach((d,k)=> d.classList.toggle('is-active', k===i));
    slides.forEach((s,k)=> s.setAttribute('aria-current', k===i ? 'true' : 'false'));
    const color = slides[i].dataset.color;
    colorLabel.textContent = color;
    chips.forEach(c=> c.classList.toggle('is-active', c.dataset.color === color));
    count.textContent = (i+1) + ' / ' + slides.length;
    prev.hidden = i === 0;
    next.hidden = i === slides.length-1;
  }
  track.addEventListener('scroll', ()=>{
    if(!ticking){ ticking = true; requestAnimationFrame(update); }
  }, {passive:true});
  window.addEventListener('resize', update);

  prev.addEventListener('click', ()=> goTo(current-1));
  next.addEventListener('click', ()=> goTo(current+1));
  dots.forEach((d,k)=> d.addEventListener('click', ()=> goTo(k)));
  chips.forEach(c=> c.addEventListener('click', ()=>{
    const first = slides.findIndex(s=> s.dataset.color === c.dataset.color);
    if(first > -1) goTo(first);
  }));
  update();
})();
})();


// Hover to zoom: magnify the photo under the cursor (mouse devices only)
(function(){
  if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  document.addEventListener('mousemove', function(e){
    var f = e.target.closest && e.target.closest('.zoom, .nnw-photo, .pieces-grid figure');
    if(!f) return;
    var img = f.querySelector('img'); if(!img) return;
    var r = f.getBoundingClientRect();
    img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
  }, {passive:true});
})();


// ===== Mobile menu =====
(function(){
  var nav=document.querySelector('.site-nav'); if(!nav) return;
  var btn=nav.querySelector('.nav-toggle'); if(!btn) return;
  function setOpen(o){ nav.classList.toggle('open',o); btn.setAttribute('aria-expanded',o?'true':'false'); btn.setAttribute('aria-label',o?'Close menu':'Open menu'); }
  btn.addEventListener('click',function(){ setOpen(!nav.classList.contains('open')); });
  nav.querySelectorAll('.nav-links a').forEach(function(a){ a.addEventListener('click',function(){ setOpen(false); }); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') setOpen(false); });
})();

// ===== Add to cart: item flies into the cart icon =====
(function(){
  var cartLink=document.querySelector('.nav-cart'); if(!cartLink) return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  function setCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(e){ e.textContent=n; e.hidden=(n===0); });
    cartLink.setAttribute('aria-label','Cart, '+n+' items');
  }
  function bump(){ cartLink.classList.remove('bump'); void cartLink.offsetWidth; cartLink.classList.add('bump'); }
  // Every item being added gets its own photo to fly: one for a product, one per piece for a set.
  function findImages(form){
    var set=form.closest('.set-card');
    if(set){ return Array.prototype.slice.call(set.querySelectorAll('.set-media img')); }
    var rk=form.closest('.rack-item');
    if(rk){ var rf=rk.querySelector('img.rack-front'); return rf?[rf]:[]; }
    var card=form.closest('.p-card');
    if(card){ var f=card.querySelector('img.front') || card.querySelector('img'); return f?[f]:[]; }
    var one=document.querySelector('.product-media [data-color]:not([hidden]) img') || document.querySelector('.product-media img');
    return one?[one]:[];
  }
  function fly(img,done){
    if(!img || reduce.matches){ done(); return; }
    var r=img.getBoundingClientRect(), t=cartLink.getBoundingClientRect();
    if(!r.width || !r.height){ done(); return; }
    var size=Math.min(190, r.width), ratio=r.height/r.width;
    var w=size, h=size*ratio;
    var startX=r.left+(r.width-w)/2, startY=Math.max(8, Math.min(r.top+(r.height-h)/2, window.innerHeight-h-8));
    var clone=document.createElement('img');
    clone.className='fly-img'; clone.src=img.currentSrc||img.src; clone.alt='';
    clone.style.cssText='left:'+startX+'px;top:'+startY+'px;width:'+w+'px;height:'+h+'px;';
    document.body.appendChild(clone);
    var endX=t.left+t.width/2, endY=t.top+t.height/2;
    var dx=endX-(startX+w/2), dy=endY-(startY+h/2);
    var scaleEnd=Math.max(0.08, 26/Math.max(w,h));
    var anim=clone.animate([
      { transform:'translate(0,0) scale(1) rotate(0deg)', opacity:1, offset:0 },
      { transform:'translate('+(dx*0.45)+'px,'+(dy*0.45-70)+'px) scale(0.6) rotate(-8deg)', opacity:0.95, offset:0.5 },
      { transform:'translate('+dx+'px,'+dy+'px) scale('+scaleEnd+') rotate(10deg)', opacity:0.35, offset:1 }
    ],{ duration:850, easing:'cubic-bezier(.45,.05,.25,1)', fill:'forwards' });
    anim.onfinish=function(){ clone.remove(); done(); };
    anim.oncancel=function(){ clone.remove(); done(); };
    setTimeout(function(){ if(clone.isConnected){ anim.cancel(); } },1800); // safety: never leave the cart count waiting
  }

  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]');
    if(btn && btn.disabled) return;
    var label=btn?btn.textContent:'';
    var imgs=findImages(f);
    if(btn){ btn.disabled=true; btn.textContent='Adding\u2026'; }
    // Take off right away; update the cart count when both the animation and the request are done.
    // Items take off one after another (about 0.17s apart); the count updates once the last one lands.
    // If the page isn't visible, browsers freeze timers and animations, so skip the flight and just update the cart.
    var landed=(document.hidden || document.visibilityState==='hidden') ? Promise.resolve() : Promise.all((imgs.length?imgs:[null]).map(function(im,i){
      return new Promise(function(res){
        setTimeout(function(){ fly(im,function(){ bump(); res(); }); }, i*170);
      });
    }));
    var request=fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }); });
    Promise.all([landed,request])
      .then(function(out){
        setCount(out[1].item_count); bump(); document.dispatchEvent(new Event('st:cart-added'));
        if(btn){ btn.textContent='Added \u2713'; setTimeout(function(){ btn.disabled=false; btn.textContent=label; },1400); }
      })
      .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=label; } HTMLFormElement.prototype.submit.call(f); });
  });
})();


// ===== Flip tiles: tap to see the back, tap again for the front =====
(function(){
  document.addEventListener('click',function(e){
    var t=e.target.closest && e.target.closest('.flip-tile'); if(!t) return;
    var on=t.classList.toggle('is-flipped');
    t.setAttribute('aria-pressed', on?'true':'false');
    var cap=t.querySelector('[data-cap]'); if(cap) cap.innerHTML = on ? t.getAttribute('data-back') : t.getAttribute('data-front');
  });
})();


// ===== Product photos: dots under the swipe gallery (phones) =====
(function(){
  var pm=document.querySelector('.product-media'); if(!pm) return;
  var dots=document.createElement('div'); dots.className='pm-dots'; pm.parentNode.insertBefore(dots,pm.nextSibling);
  function slides(){ return [].slice.call(pm.children).filter(function(s){ return !s.hidden; }); }
  function mark(){ var i=Math.round(pm.scrollLeft/(pm.clientWidth||1)); [].forEach.call(dots.children,function(d,k){ d.classList.toggle('is-on',k===i); }); }
  function build(){
    var s=slides(); dots.innerHTML='';
    s.forEach(function(sl,k){ var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Photo '+(k+1)); b.addEventListener('click',function(){ pm.scrollTo({left:k*pm.clientWidth,behavior:'smooth'}); }); dots.appendChild(b); });
    mark();
  }
  pm.addEventListener('scroll',function(){ requestAnimationFrame(mark); },{passive:true});
  new MutationObserver(function(){ pm.scrollLeft=0; build(); }).observe(pm,{attributes:true,subtree:true,attributeFilter:['hidden']});
  build();
})();
